import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowConsent(true);
    }
  }, []);

  const handleConsent = (choice) => {
    localStorage.setItem('cookieConsent', choice);
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t p-2 md:p-4 z-50">
      <div className="container mx-auto max-w-6xl flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4">
        <p className="text-gray-600 text-xs md:text-sm px-2 md:px-0">
          Daha iyi hizmet sunabilmek için sitemizde çerezler kullanıyoruz.{' '}
          <Link to="/cerez-politikasi" className="text-blue-500 hover:text-blue-600">
            Çerez politikamıza göz atabilirsin.
          </Link>
        </p>
        
        <div className="flex items-center gap-2 md:gap-3">

          <button
            onClick={() => handleConsent('rejected')}
            className="px-3 md:px-4 py-1.5 md:py-2 text-xs md:text-sm bg-gray-100 text-gray-600 rounded hover:bg-gray-200"
          >
            Reddet
          </button>
          <button
            onClick={() => handleConsent('accepted')}
            className="px-3 md:px-4 py-1.5 md:py-2 text-xs md:text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;